import React from "react";
import { isVisibleToReaders, type SetReaderVisible } from "../../schemas/book-schemas";

/**
 * Ô tick bật/tắt cả một chương hoặc tiết với người đọc
 * (`section.visible_to_readers`). Tắt thì app đọc sách không nhận mục này với
 * bất kỳ vai trò nào; mục vẫn nằm đây để bật lại, không phải tải lại file.
 */
export const ReaderVisibleToggle: React.FC<{
  section?: { id?: string; visible_to_readers?: boolean } | null;
  /** "chương" hoặc "phần", để câu giải thích khớp với chỗ đặt ô tick */
  noun: string;
  onSetReaderVisible?: SetReaderVisible;
}> = ({ section, noun, onSetReaderVisible }) => {
  if (!onSetReaderVisible || !section?.id) {
    return null;
  }

  const visible = isVisibleToReaders(section);

  // Rộng tối thiểu theo nhãn dài hơn ("Hiện trong sách"): đổi nhãn khi bật/tắt
  // không làm nút xoá bên cạnh nhảy ngang.

  return (
    <label
      className={`flex items-center min-w-[140px] h-8 px-3 rounded-lg border text-xs font-medium cursor-pointer select-none transition-colors ${
        visible
          ? "bg-white border-gray-200 text-gray-700 hover:bg-gray-50 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-300"
          : "bg-red-50 border-red-200 text-red-700 dark:bg-red-900/30 dark:border-red-700 dark:text-red-300"
      }`}
      title={
        visible
          ? `Người đọc thấy ${noun} này. Bỏ tick để ẩn khỏi sách với mọi người (giáo viên và học sinh).`
          : `${noun[0].toUpperCase()}${noun.slice(1)} này đã tắt: app đọc sách không nhận, kể cả giáo viên. Tick để bật lại.`
      }
      data-testid="reader-visible-toggle"
    >
      <input
        type="checkbox"
        className="h-3.5 w-3.5 mr-2 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
        checked={visible}
        onChange={(e) => onSetReaderVisible(section.id!, e.target.checked)}
      />
      {visible ? "Hiện trong sách" : "Đã tắt"}
    </label>
  );
};
